import { inject, InjectionKey, provide, ref, Ref } from "vue";

function createIOProvider(testing: boolean): Ref<IntersectionObserverEntry> {
  const entry = ref<IntersectionObserverEntry>({
    isIntersecting: true,
    time: 0
  } as IntersectionObserverEntry);
  const isIntersecting = ref(false);

  if (testing) return entry;

  if (!window.IntersectionObserver) return entry;

  const observer = new IntersectionObserver(
    entries => {
      if (entries[0].isIntersecting && !isIntersecting.value) {
        entry.value = entries[0];
        isIntersecting.value = true;
      }
    },
    { root: null, threshold: 1.0 }
  );

  const target = document.querySelector("#app") as Element;

  if (target) observer.observe(target);

  return entry;
}

export type injectIntersectionObserverReturnType = ReturnType<
  typeof createIOProvider
>;

const IntersectionObserverKey: InjectionKey<injectIntersectionObserverReturnType> = Symbol(
  "intersection-observer"
);

export function provideIntersectionObserver(testing = false): void {
  return provide(IntersectionObserverKey, createIOProvider(testing));
}

export function injectIntersectionObserver(): injectIntersectionObserverReturnType {
  return inject(
    IntersectionObserverKey,
    ref<IntersectionObserverEntry>({} as IntersectionObserverEntry)
  );
}
